import PropTypes from 'prop-types'

export default PropTypes.shape({
  theme: PropTypes.object.isRequired,
})
